export default "__VITE_ASSET__BQQVcvHz__"